function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.153076,
  y: 0.152344,
  width: 9.81887,
  height: 3.4366,
  rx: 1.5,
  fill: "white"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 13.4084,
  y: 0.152344,
  width: 3.4366,
  height: 3.4366,
  rx: 1.5,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 9.97168,
  y: 13.4082,
  width: 6.87321,
  height: 3.4366,
  rx: 1.5,
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.152832,
  y: 13.4082,
  width: 6.87321,
  height: 3.4366,
  rx: 1.5,
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.152832,
  y: 6.53516,
  width: 16.6921,
  height: 3.4366,
  rx: 1.5,
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/ghost.d91cca52.svg";
export { SvgComponent as ReactComponent };